import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Construction } from 'lucide-react';

export default function ComingSoonPage() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <Construction className="h-16 w-16 text-primary-500 mb-4" />
      <h1 className="text-2xl font-bold text-secondary-900 mb-2">
        {t('comingSoon', 'Coming Soon')}
      </h1>
      <p className="text-secondary-600 mb-4">
        {t('pageUnderConstruction', 'This page is under construction')}
      </p>
      <code className="bg-secondary-100 px-3 py-1 rounded text-sm text-secondary-700">
        {location.pathname}
      </code>
    </div>
  );
}
